export const toF = (celsius) => {
  return (celsius * 9/5) + 32;
};

export const toMph = (mps) => {
    return mps / 2.23694;
}